<script setup>
import EmojiOrIcon from 'shared/components/EmojiOrIcon.vue';

defineProps({
  title: {
    type: String,
    required: true,
  },
  compact: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: String,
    default: '',
  },
  emoji: {
    type: String,
    default: '',
  },
  isOpen: {
    type: Boolean,
    default: true,
  },
  // SuperTVGo: o `overflow-hidden` daqui embaixo existe só pra manter o
  // conteúdo dentro do border-radius do card. Ele também corta qualquer
  // dropdown absoluto que precise crescer além da altura do card (etiquetas
  // e atributos de contato, por ex.) — opt-in pra não arriscar os outros
  // usos do componente, que não têm esse problema.
  overflowVisible: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['toggle']);

const onToggle = () => {
  emit('toggle');
};
</script>

<template>
  <div
    class="text-sm rounded-xl outline outline-1 outline-n-weak bg-n-solid-1 transition-colors"
    :class="overflowVisible ? 'overflow-visible' : 'overflow-hidden'"
  >
    <button
      class="flex items-center select-none w-full gap-2.5 m-0 cursor-grab justify-between py-3 px-4 drag-handle hover:bg-n-solid-2 transition-colors"
      @click.stop="onToggle"
    >
      <div class="flex items-center gap-2.5 min-w-0">
        <EmojiOrIcon
          v-if="icon || emoji"
          class="inline-block w-5 shrink-0 text-n-slate-11"
          :icon="icon"
          :emoji="emoji"
        />
        <h5
          class="text-n-slate-12 text-sm font-semibold mb-0 py-0 truncate text-left rtl:text-right"
        >
          {{ title }}
        </h5>
      </div>
      <div class="flex flex-row items-center gap-1 shrink-0">
        <slot name="button" />
        <span
          class="i-lucide-chevron-down text-base text-n-slate-11 transition-transform duration-200"
          :class="{ 'rotate-180': isOpen }"
        />
      </div>
    </button>
    <div
      v-if="isOpen"
      class="border-t border-n-weak"
      :class="compact ? 'p-0' : 'px-4 py-4'"
    >
      <slot />
    </div>
  </div>
</template>
